module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "statsMaincategory"
  }, [(_vm.settings) ? _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "link text-right closeBtn",
    on: {
      "click": function($event) {
        _vm.closeSettings();
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sort = '';
        _vm.fetchData();
        _vm.closeSettings();
      }
    }
  }, [_vm._v("Alle anzeigen")]), _vm._v(" "), _c('p', {
    staticClass: "divider"
  }, [_vm._v("Sortieren")]), _vm._v(" "), _c('p', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sort = 'alpha';
        _vm.fetchData();
        _vm.closeSettings();
      }
    }
  }, [_vm._v("Alphabetisch")]), _vm._v(" "), _c('p', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sort = 'revenues';
        _vm.fetchData();
        _vm.closeSettings();
      }
    }
  }, [_vm._v("Nach Umsatz")])]) : _vm._e(), _vm._v(" "), (_vm.loaderSm) ? _c('div', {
    staticClass: "loader-wrapper-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.loaderSm) ? _c('div', {
    staticClass: "loader-sm"
  }) : _vm._e(), _vm._v(" "), (!_vm.$route.params.year) ? _c('card', {
    attrs: {
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "chartWrapper"
  }, [_c('div', {
    staticClass: "chart col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right"
  }, [_c('div', {
    attrs: {
      "id": "chartHkCustomer"
    }
  })])])])]), _vm._v(" "), _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.yearslist[0]), function(year, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsmy',
          params: {
            year: year.jahr
          }
        }
      }
    }, [_c('td', [_vm._v(_vm._s(year.jahr) + " "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("GS: " + _vm._s(year.gewinnSpanne) + " | WB: " + _vm._s(year.webQuote))])]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(year.umsatz)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.year && !_vm.$route.params.cat) ? _c('card', {
    attrs: {
      "title": "Hauptkategorien Statistik",
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('router-link', {
    staticClass: "back",
    attrs: {
      "tag": "div",
      "to": "/dashboard/stats/maincategories"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.settings = !_vm.settings
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chartWrapper"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.sort == 'revenues') ? _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "200px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.vG2r == 1) ? _c('svg', {
    attrs: {
      "id": "vG2r-2",
      "width": "300",
      "height": "300"
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "names"
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v("Hauptgruppen")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Alle")])])]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.yearslist[1]), function(item, index) {
    return _c('router-link', {
      key: index,
      class: {
        active: _vm.$route.params.year == item.jahr
      },
      attrs: {
        "to": {
          name: 'dsmy',
          params: {
            year: item.jahr
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.setYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.jahr) + "\r\n                ")])
  })), _vm._v(" "), (_vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', [_vm._l((_vm.categories), function(category, index) {
    return (index < 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsmc',
          params: {
            year: _vm.$route.params.year,
            cat: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzVj > 0) ? _c('span', [(category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €"), _c('br'), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.categories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                            Andere\r\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.categories), function(category, index) {
    return (index >= 5) ? _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsmc',
          params: {
            year: _vm.$route.params.year,
            cat: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzVj > 0) ? _c('span', [(category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €"), _c('br'), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.sort != 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.categories), function(category, index) {
    return _c('router-link', {
      key: category.id,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsmc',
          params: {
            year: _vm.$route.params.year,
            cat: category.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('hatg', category.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('td', [(category.umsatzVj > 0) ? _c('span', [(category.umsatzLj > category.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(category.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzLj)) + " €"), _c('br'), (category.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(category.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.year && _vm.$route.params.cat && !_vm.$route.params.scat) ? _c('card', {
    attrs: {
      "title": "Hauptkategorien Statistik",
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('router-link', {
    staticClass: "back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'dsmy',
        params: {
          year: _vm.$route.params.year
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.settings = !_vm.settings
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chartWrapper"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.sort == 'revenues') ? _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "200px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.vG3r == 1) ? _c('svg', {
    attrs: {
      "id": "vG3r-2",
      "width": "300",
      "height": "300"
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "names"
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v(_vm._s(_vm.names.hatg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Artikelgruppen")])])]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.yearslist[1]), function(item, index) {
    return _c('router-link', {
      key: index,
      class: {
        active: _vm.$route.params.year == item.jahr
      },
      attrs: {
        "to": {
          name: 'dsmc',
          params: {
            year: item.jahr,
            cat: _vm.$route.params.cat
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.setYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.jahr) + "\r\n                ")])
  })), _vm._v(" "), (_vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', [_vm._l((_vm.subcategories), function(subcategory, index) {
    return (index < 5) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsms',
          params: {
            year: _vm.$route.params.year,
            cat: _vm.$route.params.cat,
            scat: subcategory.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', subcategory.name)
        }
      }
    }, [_c('td', {
      staticClass: "colorPill"
    }, [_c('span', {
      staticClass: "colorPill"
    }), _vm._v(_vm._s(subcategory.name))]), _vm._v(" "), _c('td', [(subcategory.umsatzVj > 0) ? _c('span', [(subcategory.umsatzLj > subcategory.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (subcategory.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.subcategories.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                            Andere\r\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(subcategory, index) {
    return (index >= 5) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsms',
          params: {
            year: _vm.$route.params.year,
            cat: _vm.$route.params.cat,
            scat: subcategory.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', subcategory.name)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(subcategory.name))]), _vm._v(" "), _c('td', [(subcategory.umsatzVj > 0) ? _c('span', [(subcategory.umsatzLj > subcategory.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (subcategory.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.sort != 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.subcategories), function(subcategory, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'dsms',
          params: {
            year: _vm.$route.params.year,
            cat: _vm.$route.params.cat,
            scat: subcategory.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.setName('atg', subcategory.name)
        }
      }
    }, [_c('td', [_vm._v(" " + _vm._s(subcategory.name))]), _vm._v(" "), _c('td', [(subcategory.umsatzVj > 0) ? _c('span', [(subcategory.umsatzLj > subcategory.umsatzVj) ? _c('span', {
      staticClass: "upward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward"
    }, [_c('br'), _vm._v("(" + _vm._s(subcategory.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (subcategory.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(subcategory.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.year && _vm.$route.params.cat && _vm.$route.params.scat && !_vm.$route.params.brand) ? _c('card', {
    attrs: {
      "title": "Hauptkategorien Statistik",
      "addition-class-name": "card-mini",
      "body-class": "no-padding table-responsiveXX"
    }
  }, [_c('router-link', {
    staticClass: "back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'dsmc',
        params: {
          year: _vm.$route.params.year,
          cat: _vm.$route.params.cat
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.settings = !_vm.settings
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chartWrapper"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "names"
  }, [_c('span', {
    staticClass: "title-one"
  }, [_vm._v(_vm._s(_vm.names.atg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title-two"
  }, [_vm._v("Marken")])])]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, _vm._l((_vm.yearslist[1]), function(item, index) {
    return _c('router-link', {
      key: index,
      class: {
        active: _vm.$route.params.year == item.jahr
      },
      attrs: {
        "to": {
          name: 'dsms',
          params: {
            year: item.jahr,
            cat: _vm.$route.params.cat,
            scat: _vm.$route.params.scat
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.setYear(item.jahr)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(item.jahr) + "\r\n                ")])
  })), _vm._v(" "), (_vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', [_vm._l((_vm.brands), function(brand, index) {
    return (index < 5) ? _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "colorPillX"
    }, [_c('span', {
      staticClass: "colorPillX"
    }), _vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzVj > 0) ? _c('span', [(brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward text-success"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward text-danger"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.brands.length > 5) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.showmore = !_vm.showmore
      }
    }
  }, [_c('td', [_vm._v("\r\n                            Andere\r\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                            " + _vm._s(_vm._f("myCurrency")(4678956)) + " €\r\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('span', {
    staticClass: "next"
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.showmore && _vm.sort == 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(brand, index) {
    return (index >= 5) ? _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzVj > 0) ? _c('span', [(brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward text-success"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward text-danger"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.sort != 'revenues') ? _c('table', {
    staticClass: "table card-table"
  }, [_c('tbody', _vm._l((_vm.brands), function(brand, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(brand.name))]), _vm._v(" "), _c('td', [(brand.umsatzVj > 0) ? _c('span', [(brand.umsatzLj > brand.umsatzVj) ? _c('span', {
      staticClass: "upward text-success"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")]) : _c('span', {
      staticClass: "downward text-danger"
    }, [_c('br'), _vm._v("(" + _vm._s(brand.umsatzDiff) + "%)")])]) : _vm._e(), _vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzLj)) + " €"), _c('br'), _vm._v(" "), (brand.umsatzVj > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("myCurrency")(brand.umsatzVj)) + " €")]) : _c('span', [_vm._v("-")])])])
  }))]) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdee1bc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/StatsMaincategory.html
// module id = 567
// module chunks = 1